module.exports = __webpack_public_path__ + "static/media/get_insured_carousel_1.f73f5fc4.svg";